import PropTypes from 'prop-types';
import React from 'react';

export default class MatchResults extends React.Component {
  static propTypes = {
    item: PropTypes.object,
  };
  render() {
    const {item} = this.props;
    const {matchTitle, winners, description} = item;
    const winnersList = winners || [];
    const peeps = winnersList.map((winner, index) => {
      const key = `winner-${index}`;
      return <li key={key}>{winner}</li>;
    });
    return (
      <div className="col-xs-12 col-sm-4">
        <div className="match-results container-fluid text-center">
          <div className="results container-fluid">
            <div className="row">
              <div className="col-xs-5 blue no-padding">
                <h3>{matchTitle}</h3>
              </div>
              <div className="col-xs-7 orange no-padding">
                <ul className="winners">{peeps}</ul>
              </div>
            </div>
          </div>
          <div className="details text-left">
            <p>{description}</p>
          </div>
        </div>
      </div>
    );
  }
}
